import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const privacyContent = <div className="space-y-4 text-charcoal-light text-sm leading-relaxed" data-id="element-46">
      <p data-id="element-47">
        We respect your privacy and are committed to protecting your personal
        information. This Privacy Policy explains how we collect, use, and
        safeguard your data when you purchase and use our digital products.
      </p>
      <h4 className="font-semibold text-charcoal text-base" data-id="element-48">
        Information We Collect
      </h4>
      <p data-id="element-49">
        When you make a purchase, we collect your name, email address, and
        payment information. Payment processing is handled securely by our
        third-party payment provider. We do not store your full credit card
        details.
      </p>
      <h4 className="font-semibold text-charcoal text-base" data-id="element-50">
        How We Use Your Information
      </h4>
      <p data-id="element-51">
        Your information is used solely to deliver your purchased product, send
        order confirmations, and provide customer support. We may also send
        occasional updates related to your purchase.
      </p>
      <h4 className="font-semibold text-charcoal text-base" data-id="element-52">Data Protection</h4>
      <p data-id="element-53">
        We implement appropriate security measures to protect your personal
        information. We do not sell, trade, or share your personal data with
        third parties for marketing purposes.
      </p>
      <h4 className="font-semibold text-charcoal text-base" data-id="element-54">Your Rights</h4>
      <p data-id="element-55">
        You may request access to, correction of, or deletion of your personal
        data at any time.
      </p>
    </div>;
  const termsContent = <div className="space-y-4 text-charcoal-light text-sm leading-relaxed" data-id="element-56">
      <p data-id="element-57">
        By purchasing and accessing this digital product, you agree to the
        following terms and conditions. Please read them carefully before
        completing your purchase.
      </p>
      <h4 className="font-semibold text-charcoal text-base" data-id="element-58">
        Digital Product Delivery
      </h4>
      <p data-id="element-59">
        Upon successful payment, you will receive immediate access to the
        digital product. The product is delivered electronically and can be
        accessed on any device.
      </p>
      <h4 className="font-semibold text-charcoal text-base" data-id="element-60">Usage Rights</h4>
      <p data-id="element-61">
        Your purchase grants you a personal, non-transferable license to use the
        product for your own personal use. You may not redistribute, resell, or
        share the product with others.
      </p>
      <h4 className="font-semibold text-charcoal text-base" data-id="element-62">Refund Policy</h4>
      <p data-id="element-63">
        Due to the digital nature of this product, all sales are final. If you
        experience any technical issues accessing your purchase, please reach
        out and we will resolve the issue promptly.
      </p>
      <h4 className="font-semibold text-charcoal text-base" data-id="element-64">Disclaimer</h4>
      <p data-id="element-65">
        This product is for educational and informational purposes only. It is
        not a substitute for professional medical advice, diagnosis, or
        treatment. Always consult a qualified healthcare provider with any
        questions regarding a medical condition.
      </p>
    </div>;
  return <>
      <footer className="py-6 bg-sage-dark text-white/70 text-sm text-center" data-id="element-66">
        <div className="flex justify-center gap-6" data-id="element-67">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors" data-id="element-68">
            Privacy Policy
          </button>
          <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors" data-id="element-69">
            Terms of Service
          </button>
        </div>
        <p className="mt-4 text-[11px] text-white/40 max-w-lg mx-auto leading-relaxed px-4" data-id="element-70">
          © 2026 The Nervous System Reset. All rights reserved. This
          educational resource is not affiliated with or endorsed by Facebook
          and does not constitute legal, medical, or financial advice. Results
          vary; consult a qualified professional. By using this site you agree
          to our Privacy Policy & Terms of Service.
        </p>
      </footer>

      <AnimatePresence data-id="element-71">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-72">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-sage-dark/40 backdrop-blur-sm" data-id="element-73" />

            {/* Modal */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} transition={{
          duration: 0.25
        }} onClick={e => e.stopPropagation()} className="bg-cream/95 backdrop-blur-md rounded-2xl p-5 md:p-6 max-w-md w-full max-h-[70vh] overflow-y-auto relative shadow-xl border border-sand" data-id="element-74">
              <button onClick={() => setActiveModal(null)} className="absolute top-3 right-3 p-1.5 text-charcoal-light hover:text-charcoal bg-sand/60 rounded-full transition-colors" data-id="element-75">
                <XIcon className="w-4 h-4" data-id="element-76" />
              </button>
              <h3 className="font-serif text-xl text-charcoal mb-4" data-id="element-77">
                {activeModal === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
              </h3>
              {activeModal === 'privacy' ? privacyContent : termsContent}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}